import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MDBModalRef, MDBModalService, ModalDirective } from 'angular-bootstrap-md';
import { SuccessDialogComponent } from '../shared/success-dialog/success-dialog.component';
import { ReportsService } from './reports.service';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit {
  yearArray: any;
  xlname: any;
  reportsData: any;
  selectedYear: any = "--Select--";
  January: boolean = false;
  February : boolean = false;
  March: boolean = false;
  April: boolean = false;
  May: boolean = false;
  June: boolean = false;
  July: boolean = false;
  August: boolean = false;
  September: boolean = false;
  October: boolean = false;
  November: boolean = false;
  December: boolean = false;
  Total:boolean = false;
  RssoLogin : boolean = false;
  SoLogin: boolean = false;
  AbmLogin: boolean = false;
  RbmLogin: boolean = false;
  NsmLogin: boolean = false;
  xldata: any;
  @ViewChild('downloads', { static: true }) divClick: ElementRef;
  @ViewChild('exportModal', { static: true }) public downloadModalOnClick: ModalDirective;

  constructor(public reportsService: ReportsService, private sanitizer: DomSanitizer, private modalService: MDBModalService, ) {
    let data = JSON.parse(sessionStorage.getItem('userDetails'));
    if(data.DesigId == 4) {
      this.RssoLogin = true;
     
    } else if(data.DesigId == 6) {
      this.SoLogin = true;
    } else if(data.DesigId == 7) {
      this.AbmLogin = true;
    }
    else if(data.DesigId == 8 ) {
      this.RbmLogin = true;
    }
    else if(data.DesigId == 9) {
      this.NsmLogin = true;
    }
   }

  ngOnInit() {
    this.getFinancialYear();
    this.getReportee();
  }
  reporteeArray: any = [];
  selectedReportee: any = '--Select--';
  getReportee() {
    this.reportsService.getReportee().then((data: any) => {
      if(data != null) {
        this.reporteeArray = data;
        if(this.NsmLogin) {
        this.selectedReportee = this.reporteeArray[0].DealUserName;
        }
      }
     
    }, errorCode => console.log(errorCode));
  }

  getFinancialYear() {
    this.reportsService.getFinancialYear().then((data: any) => {
     this.yearArray = data;
    }, errorCode => console.log(errorCode));
  }
  columnsList: any;
  displayTable: boolean = false;

  getReports() {
if(this.selectedYear != '--Select--') {
 this.reportsService.getReports(this.selectedYear, this.selectedReportee).then((data: any) => {
     this.columnsList = data[0];
     if(data.length> 0) {
       this.displayTable = true;
     if(this.columnsList.Apr_Price != null ){
      this.April = true;
     }else {
      this.April = false;
     }
     if(this.columnsList.May_Price != null ){
      this.May = true;
     }else {
      this.May = false;
     }
     if(this.columnsList.June_Price != null ){
      this.June = true;
     }else {
      this.June = false;
     }
     if(this.columnsList.Jul_Price != null ){
      this.July = true;
     }else {
      this.July = false;
     }
     if(this.columnsList.Aug_Price != null ){
      this.August = true;
     }else {
      this.August = false;
     }
     if(this.columnsList.Sep_Price != null ){
      this.September = true;
     }else {
      this.September = false;
     }
     if(this.columnsList.Oct_Price != null ){
      this.October = true;
     }else {
      this.October = false;
     }
     if(this.columnsList.Nov_Price != null ){
      this.November = true;
     }else {
      this.November = false;
     }
     if(this.columnsList.Dec_Price != null ){
      this.December = true;
     }else {
      this.December = false;
     }
     if(this.columnsList.Jan_Price != null ){
      this.January = true;
     }else {
      this.January = false;
     }
     if(this.columnsList.Feb_Price != null ){
      this.February = true;
     }else {
      this.February = false;
     }
     if(this.columnsList.Mar_Price != null ){
      this.March = true;
     }else {
      this.March = false;
     }
     if(this.columnsList.TotPrice != null ){
      this.Total = true;
     }else {
      this.Total = false;
     }
    }
     else {
   this.displayTable = false;
     }
     this.reportsData = data;
    }, errorCode => console.log(errorCode));
  }
  }

  successModalRef: MDBModalRef;
  export(){
    if(this.selectedYear != '--Select--') {
    this.reportsService.export_Table(this.selectedYear, this.selectedReportee).then((data) => {
         console.log(data,'data')
         if (data.File) {
        this.xlname = data.FileName;
        let url = 'data:application/octet-stream;base64,'+  data.File;
        this.xldata =  this.sanitizer.bypassSecurityTrustResourceUrl(url);
        setTimeout(() => {
          this.divClick.nativeElement.click();
          }, 200);
          this.downloadModalOnClick.hide();
  
        }
        else {
          let message = "There is no file available for Export";
          this.successModalRef = this.modalService.show(SuccessDialogComponent, {
            data: {
              message: message,
              data: []
            }
          });
          this.successModalRef.content.action.subscribe(result => {
            if (result == 'OK') {
              this.successModalRef.hide();
            }
          })
         
        }
 })
}
}

}
